import { useNavigate } from 'react-router-dom';
import { formatManilaDate } from '@dispatchdash/shared';
import { tripsApi, type Trip } from '@/api/client';
import { useAsync } from '@/hooks';
import { Layout } from '@/components/Layout';
import { DataTable } from '@/components/DataTable';
import { StatusBadge } from '@/components/StatusBadge';
import { Button } from '@/components/Button';
import { internalNavItems } from '@/pages/navItems';
import { formatDate } from '@/lib/format';

export function TodayView() {
  const navigate = useNavigate();
  const today = formatManilaDate(new Date());

  const { data: trips, loading, error, reload } = useAsync(
    () => tripsApi.list({ date: today }),
    [today],
  );

  const columns = [
    { key: 'reference', header: 'Reference' },
    { key: 'clientName', header: 'Client' },
    { key: 'origin', header: 'Origin' },
    { key: 'destination', header: 'Destination' },
    {
      key: 'status',
      header: 'Status',
      render: (row: Trip) => <StatusBadge status={row.status} size="sm" />,
    },
    { key: 'vehiclePlate', header: 'Vehicle' },
    { key: 'driverName', header: 'Driver' },
  ];

  return (
    <Layout navItems={internalNavItems}>
      <div className="page">
        <div className="page-header row-between">
          <div>
            <h1>Today&apos;s trips</h1>
            <p className="text-muted">{new Date(`${today}T00:00:00+08:00`).toLocaleDateString('en-PH', { timeZone: 'Asia/Manila', weekday: 'long' })}, {formatDate(today)}</p>
          </div>
          <Button type="button" variant="secondary" onClick={() => reload()}>Refresh</Button>
        </div>

        <DataTable
          columns={columns}
          data={trips ?? []}
          keyField="id"
          loading={loading}
          loadError={error}
          dense
          onRowClick={(row) => navigate(`/app/dispatch/trips/${row.id}`)}
          emptyMessage="No trips scheduled for today. Check the dispatch board for upcoming bookings."
        />
        {error && (
          <div style={{ marginTop: 'var(--space-md)' }}>
            <Button type="button" onClick={() => reload()}>Retry</Button>
          </div>
        )}
      </div>
    </Layout>
  );
}
